import React, { useState, useCallback, useEffect } from "react";
import AgentPanel from "./AgentPanel";
import { extractDOM, serializeForLLM } from "./dom";

const PANEL_WIDTH = 360;


export default function AgentWidget() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => setIsOpen(o => !o), []);
  const close  = useCallback(() => setIsOpen(false),   []);
  useEffect(() => {
    window.toggleAgentGlobal = toggle;
    return () => { delete window.toggleAgentGlobal; };
  }, [toggle]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get("agentOpen") === "true") {
      setIsOpen(true);
    }
  }, []);

  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const snapId = params.get("__snap");
    if (!snapId) return;

   
    const channel = new BroadcastChannel("ai_agent_tabsync");
    const timer = setTimeout(() => {
      try {
        const dom      = extractDOM();
        const snapshot = serializeForLLM(dom);
        channel.postMessage({
          type:      "AGENT_SNAP_RESPONSE",
          requestId: snapId,
          snapshot,
          url:       window.location.href,
        });
      } catch (err) {
        console.error("[AgentWidget] tab snapshot error:", err);
      }
      channel.close();
      setTimeout(() => window.close(), 600);
    }, 1600);

    return () => { clearTimeout(timer); channel.close(); };
  }, []);

  useEffect(() => {
    const root = document.getElementById("main");
    if (!root) return;
    root.style.transition  = "margin-right 0.22s ease";
    root.style.marginRight = isOpen ? `${PANEL_WIDTH}px` : "0px";
    return () => { root.style.marginRight = "0px"; };
  }, [isOpen]);

  return isOpen ? <AgentPanel onClose={close} panelWidth={PANEL_WIDTH} /> : null;
}
